export interface IVendorPanelDescResponse {
  vendorPanelDescription: string;
}
